<template>
  <el-dialog
    title="xác nhận"
    :visible.sync="dialogVisible"
    width="25%"
    custom-class="authentication"
    :close-on-click-modal="false"
    :before-close="fn_closeDialog"
  >
    <el-form @submit.native.prevent>
      <div class="authentication__text">
        Nhập kết quả của phép toán để xác nhận
      </div>
      <div class="authentication__content">
        <div class="authentication__number">
          {{ first_number }} + {{ second_number }} =
        </div>
        <div class="authentication__sum">
          <input
            type="number"
            v-model="sum"
            @input="fn_check"
            autofocus
            id="authentication-input"
          />
        </div>
      </div>
      <div class="authentication__error" v-show="is_wrong">
        <i class="fa-regular fa-circle-info"></i>
        Vui lòng nhập đúng tổng 2 số
      </div>
      <el-button
        type="primary"
        class="authentication__button"
        @click="fn_accept()"
        :disabled="!sum || is_wrong"
        native-type="submit"
        >Xác nhận</el-button
      >
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  props: {
    action: String,
    idAgent: String,
  },
  data() {
    return {
      sum: undefined,
      sum_bot: undefined,
      first_number: undefined,
      second_number: undefined,
      dialogVisible: true,
      is_wrong: false,
    };
  },
  methods: {
    fn_check() {
      if (Number(this.sum) !== this.sum_bot) {
        this.is_wrong = true;
      } else this.is_wrong = false;
    },
    fn_accept() {
      this.$emit(this.action);
    },
    fn_closeDialog() {
      this.$emit("close_dialog");
    },
  },
  created() {
    this.first_number = Math.floor(Math.random() * 10);
    this.second_number = Math.floor(Math.random() * 10);
    this.sum_bot = this.first_number + this.second_number;
    setTimeout(() => {
      const dom = document.getElementById("authentication-input");
      dom.focus();
    }, 100);
  },
};
</script>
<style scoped lang="scss">
.authentication {
  &__text {
    text-align: center;
  }
  &__content {
    display: flex;
    align-items: center;
    font-size: 18px;
    justify-content: center;
    margin-top: 20px;
  }
  &__sum {
    border: thin solid #dcdcdc;
    padding: 7px 20px;
    border-radius: 5px;
    margin-left: 10px;
  }
  &__button {
    margin-top: 20px;
    width: 100%;
  }
  &__error {
    color: #e6a23c;
    text-align: center;
    top: 7px;
    position: relative;
    i {
      margin-right: 5px;
    }
  }
}
// ::v-deep .el-dialog__header {
//   border-bottom: none;
// }
::v-deep .el-input__inner {
  border: none;
  text-align: center;

  padding: 0;
  font-size: 18px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  border: none;
  text-align: center;
  width: 40px;
}
input[type="number"]:focus-visible {
  outline: none;
}
</style>
